import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import { digitalGiveawayUrlIsLoaded, openDigitalGiveawayModal } from '../../actions/app/digitalGiveaway.actions'
import { pushTrackingEvent, setTrackingState } from '../../actions/tracking/tracking.actions'
import trackingSelector from '../../selectors/tracking/trackingSelector'

const trackDigitalGiveawayMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    // Track button click event
    if (isActionOf(openDigitalGiveawayModal, action)) {
        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc digital giveaway button click',
            },
            attributes: {
                componentName: 'digital-giveaway-button',
                label: 'Digital Giveaway Button',
                currentURL: window.location.href,
                targetURL: '',
                clickID: 'digital-giveaway-button',
                elementName: 'button',
                value: '',
                pos: '',
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }

    // Track URL generation event
    if (isActionOf(digitalGiveawayUrlIsLoaded, action)) {
        const digitalGiveawayUrl = action.payload.url
        const tracking = trackingSelector(store.getState())
        const updatedTracking = {
            ...tracking,
            digitalGiveawayUrl,
        }

        store.dispatch(setTrackingState(updatedTracking, {
            causedBy: action,
        }))

        const dataLayerEvent = {
            eventInfo: {
                eventAction: 'content',
                eventName: 'dcc digital giveaway url generation',
            },
            attributes: {
                componentName: 'digital-giveaway-modal',
                label: '',
                currentURL: window.location.href,
                targetURL: '',
                clickID: '',
                elementName: '',
                value: digitalGiveawayUrl,
                pos: '',
            },
        }

        store.dispatch(pushTrackingEvent(dataLayerEvent))
    }
}

export default trackDigitalGiveawayMiddleware
